// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"938":"327e272f","991":"cccc9076"}[chunkId] + ".js";
};